import React from "react";
import { ExternalProps } from "src/types.js";
import { Pagination } from "./Pagination.js";
import { InfiniteScroll } from "./InfiniteScroll.js";
import { RecommendationsProvider } from "./providers/RecommendationsProvider.js";
import { ExternalPropsProvider } from "./providers/ExternalPropsProvider.js";

export const App = (props: ExternalProps) => {
	return (
		<ExternalPropsProvider {...props}>
			<RecommendationsProvider subvertical={props.subvertical} proxyUrl={props.proxyUrl} variant={props.variant}>
				{props.variant === "infinite-scroll" ? <InfiniteScroll /> : <Pagination />}
			</RecommendationsProvider>
		</ExternalPropsProvider>
	);
};
